import React, { useState } from "react";
import { languageHelper } from "../../config/helperFunctions";

export default function Notiofication() {

  const [checkAll, setCheckAll] = useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [ setCheckedItems] = useState([]);


  const handleCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setCheckAll(isChecked);
    setCheckedItems(isChecked ? ["item1", "item2", "item3"] : []);
  };
  return (
    <>
      <button className="flex gap-1 items-center bg-[#7B20C7] p-2 rounded-md  text-[#fff] text-xs font-semibold "
        type="button" onClick={() => setShowModal(true)} >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="fill-[#fff]" height="10" width="10">
            <path d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" /></svg>
        </span >
        {languageHelper("Notification")} (0)
      </button>
      {
        showModal ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative mx-auto w-1/2">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col  bg-white outline-none focus:outline-none overflow-y-auto shiftmodel">
                  {/*header*/}
                  <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">

                    <h1 className="text-xl text-[#7B20C7]">{languageHelper("Notification List")}</h1>
                    <button
                      className=" ml-auto  float-right text-2xl" onClick={() => setShowModal(false)} >
                      <span className="text-[#7B20C7]"> × </span>
                    </button>
                  </div>
                  <div className="p-4">
                    <input id="checkAll" className="mr-2" type="checkbox" checked={checkAll}
                      onChange={handleCheckAllChange} />
                    Select All
                  </div><hr className="min-h-0.5  w-auto mx-2" />
                  {/*body*/}
                  <div className="relative p-4 text-start h-40 bg-[#85848615]">
                    <p className="  text-sm">

                    </p>
                  </div>

                  <div className="flex items-center justify-between p-6 border-t border-solid border-blueGray-200 rounded-b">

                    <button
                      className="text-[#7B20C7]  text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                      type="submit"
                      onClick={() => setShowModal(false)}>
                      Back</button>

                    <button
                      className="text-[#7B20C7] text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                      type="submit"
                    >
                      Remove</button>


                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null
      }
    </>
  );
}
